import type { ActionButtonsProps } from './types';

export const ActionButtons = ({
  running,
  onUploadFiles,
  onPrimaryAction,
  onSecondaryAction,
  onImportDataOnly,
  primaryLabel,
  secondaryLabel,
  showPrimary,
  showSecondary,
  showImportDataOnly,
}: ActionButtonsProps) => {
  const btnBase =
    'px-5 py-2.5 rounded-md font-semibold text-sm text-white cursor-pointer transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div className="flex gap-3 flex-wrap">
      <button
        className={`${btnBase} bg-[#1f6feb] hover:opacity-85`}
        onClick={onUploadFiles}
        disabled={running}
      >
        Upload Files
      </button>
      {showPrimary && (
        <button
          className={`${btnBase} bg-[#238636] hover:opacity-85`}
          onClick={onPrimaryAction}
          disabled={running}
        >
          {primaryLabel}
        </button>
      )}
      {showSecondary && (
        <button
          className={`${btnBase} bg-[#da3633] hover:opacity-85`}
          onClick={onSecondaryAction}
          disabled={running}
        >
          {secondaryLabel}
        </button>
      )}
      {showImportDataOnly && onImportDataOnly && (
        <button
          className={`${btnBase} bg-[#d29922] hover:opacity-85`}
          onClick={onImportDataOnly}
          disabled={running}
        >
          Import Data to Database Only
        </button>
      )}
    </div>
  );
};
